let live_questions = [
  [
    [
      "instrumental",
      "ambitious",
      "Ambitious",
      "hardworking and aspiring",
      "طموح",
      "مجتهد, طموح",
      "",
    ],
    [
      "instrumental",
      "independent",
      "Independent",
      "self-reliant, self-suffient",
      "مستقل",
      "معتمد على الذات, مكتفي ذاتيا",
      "",
    ],
    [
      "instrumental",
      "broadminded",
      "Broad-minded",
      "open-minded",
      "واسع الأفق",
      "منفتح",
      "",
    ],
    [
      "instrumental",
      "intellectual",
      "Intellectual",
      "intelligent and reflective",
      "مفكر",
      "ذكي ومتأمل",
      "",
    ],
    ["instrumental", "capable", "Capable", "competent", "قادر ", "كفؤ", ""],
    [
      "instrumental",
      "logical",
      "Logical",
      "consistent, rational",
      "منطقي",
      "متسق وعقلاني",
      "",
    ],
    [
      "instrumental",
      "clean",
      "Clean",
      "neat and tidy",
      "نظيف",
      "أنيق ومرتب",
      "",
    ],
    [
      "instrumental",
      "loving",
      "Loving",
      "affectionate and tender",
      "محب",
      "حنون وحساس",
      "",
    ],
    [
      "instrumental",
      "courageous",
      "Courageous",
      "standing up for your beliefs",
      "شجاع",
      "تدافع عن معتقداتك",
      "",
    ],
    [
      "instrumental",
      "loyal",
      "Loyal",
      "faithful to friends or the group",
      "مخلص",
      "مخلص للأصدقاء أو المجموعة",
      "",
    ],
    [
      "instrumental",
      "forgiving",
      "Forgiving",
      "willing to pardon others",
      "متسامح",
      "مستعد لمسامحة الآخرين",
      "",
    ],
    [
      "instrumental",
      "obedient",
      "Obedient",
      "dutiful, respectful",
      "مطيع",
      "مطيع و محترم",
      "",
    ],
    [
      "instrumental",
      "helpful",
      "Helpful",
      "working for the welfare of others",
      "معاون",
      "تعمل من أجل مصلحة الآخرين",
      "",
    ],
    [
      "instrumental",
      "polite",
      "Polite",
      "courteous and well-mannered",
      "مهذب",
      "مهذب وخلوق ",
      "",
    ],
    [
      "instrumental",
      "honest",
      "Honest",
      "sincere and truthful",
      "صادق",
      "صادق ومخلص",
      "",
    ],
    [
      "instrumental",
      "responsible",
      "Responsible",
      "dependable and reliable",
      "مسؤول",
      "موثوق ويعتمد عليك ",
      "",
    ],
    [
      "instrumental",
      "imaginative",
      "Imaginative",
      "daring and creative",
      "واسع الخيال",
      "جريئ وخلّاق",
      "",
    ],
    [
      "instrumental",
      "self_control",
      "Self-controlled",
      "restrained, self-disciplined",
      "مسيطر على ذاتك",
      "مقيد ومنضبط ذاتيا",
      "",
    ],
  ],
  [
    [
      "terminal",
      "comfortable_life",
      "A Comfortable Life",
      "a prosperous life",
      "حياة مريحة",
      "حياة مزدهرة",
      "",
    ],
    [
      "terminal",
      "social_recognition",
      "Social Recognition",
      "respect and admiration",
      "الشهرة الإجتماعية ",
      "الاحترام والاعجاب",
      "",
    ],
    [
      "terminal",
      "equality",
      "Equality",
      "brotherhood and equal opportunity for all",
      "المساواة ",
      "الأخوة وتكافؤ الفرص للجميع",
      "",
    ],
    [
      "terminal",
      "friendship",
      "True Friendship",
      "close companionship",
      "الصداقة الحقيقية",
      "الرفقة القريبة",
      "",
    ],
    [
      "terminal",
      "exciting_life",
      "An Exciting Life",
      "a stimulating",
      "حياة مثيرة",
      "التحفيز",
      "",
    ],
    [
      "terminal",
      "wisdom",
      "Wisdom",
      "a mature understanding of life",
      "الحكمة",
      "فهم ناضج للحياة",
      "",
    ],
    [
      "terminal",
      "family_security",
      "Family Security",
      "taking care of loved ones",
      "الأمن العائلي",
      "الإعتناء بالأحبة",
      "",
    ],
    [
      "terminal",
      "world_peace",
      "A World at Peace",
      "a world free of war and conflict",
      "عالم مليئ بالسلام",
      "عالم خالٍ من الحروب والصراعات",
      "",
    ],
    [
      "terminal",
      "freedom",
      "Freedom",
      "independence and free choice",
      "الحرية",
      "الاستقلال والاختيار الحر",
      "",
    ],
    [
      "terminal",
      "world_beauty",
      "A World of Beauty",
      "beauty of nature and the arts",
      "عالم الجمال",
      "جمال الطبيعة والفنون",
      "",
    ],
    [
      "terminal",
      "health",
      "Health",
      "physical and mental well-being",
      "الصحة ",
      "الصحة البدنية والعقلية",
      "",
    ],
    [
      "terminal",
      "pleasure",
      "Pleasure",
      "an enjoyable",
      "السرور",
      "حياة ممتعة",
      "",
    ],
    [
      "terminal",
      "inner_harmony",
      "Inner Harmony",
      "freedom from inner conflict",
      "التناغم الداخلي",
      "التحرر من الصراع الداخلي",
      "",
    ],
    [
      "terminal",
      "salvation",
      "Salvation",
      "saved, eternal life",
      "الخلاص",
      "النجاة, الحياة الأبدية",
      "",
    ],
    [
      "terminal",
      "mature love",
      "Mature Love",
      "sexual and spiritual intimacy",
      "الحب الناضج",
      "العلاقة الحميمة الجنسية والروحية",
      "",
    ],
    [
      "terminal",
      "self_respect",
      "Self-respsect",
      "self-esteem",
      "احترام الذات ",
      "احترام الذات",
      "",
    ],
    [
      "terminal",
      "national_security",
      "National Security",
      "protection from attack",
      "الأمن الوطني",
      "الحماية من الهجوم",
      "",
    ],
    [
      "terminal",
      "accomplishment",
      "A Sense of Accomplishment",
      "a lasting contribution",
      "الشعور بالإنجاز",
      "مساهمة دائمة",
      "",
    ],
  ],
];

export function add_rank_questions(assessment, test = true) {
  // memory rank
  assessment.pages.push({
    title: { en: "Rank 18 values", ar: "قيم 18" },
    name: "rank_intro",
    elements: [
      {
        type: "html",
        name: "rank_intro",
        html: {
          en: ` <div className='pauze'>
                <p class='center bigSpacer medium'>You are nearly there!</p>
                <p class='center'>There are 2 more questions remaining, ranking exercises of about 4 minutes each.</p>
                <p class='center'>Rank all 18 values, one-by-one, from most important to less important by draging them into the list.</p>
                <img src="/test_assets/rank_howto.gif" style="max-width: 250px; margin: 12px auto; display: block" alt="howto"/>
                </div>`,
          ar: ` <div className='pauze'>
                <p class='center bigSpacer medium'>هناك</p>
                <p class='center'>هناك 2 أسئلة أخرى متبقية ، تمارين الترتيب حوالي 4 دقائق لكل منهما</p>
                <p class='center'>قم بترتيب القيم الثمانية عشر حسب أهميتها بالنسبة لكعن طريق سحبهم إلى القائمة</p>
                <img src="/test_assets/rank_howto.gif" style="max-width: 250px; margin: 12px auto; display: block" alt="howto"/>
                </div>`,
        },
      },
    ],
  });

  // export correct json
  (test ? [live_questions[0]] : live_questions).forEach((question) => {
    let data = {
      name: question[0][0],
      elements: [
        {
          title: {
            en: "You will now see 18 values, one-by-one",
            ar: "سترى 18 قيمًا ، واحدة تلو الأخرى",
          },
          description: {
            en: "Rank all 18 values, one-by-one, from most important to less important",
            ar: "قم بترتيب القيم الثمانية عشر حسب أهميتها بالنسبة لك",
          },
          name: question[0][0],
          type: "ranking",
          isRequired: true,
          colCount: 0,
          choices: [],
        },
      ],
    };

    // add all choices
    // (test ? [question[0], question[1], question[2], question[3]] : question).forEach((choice) => {
    question.forEach((choice) => {
      data.elements[0].choices.push({
        value: choice[1],
        text: {
          en: `${choice[2]}+${choice[3]}`,
          ar: `${choice[4]}+${choice[5]}`,
        },
      });
    });
    assessment.pages.push(data);
  });
}
